import extend from 'lodash/extend';
import { Injectable } from '@angular/core';

import { generateNameId, IPaginatedResponse } from '@cakeiteasy/web-utils';
import { ProductsApiService } from '../services/products-api.service';
import { IFilterCategory } from '../../cakes-overview/models/i-filter-category';
import { CitiesApiService } from '../services/cities-api.service';

@Injectable()
export class CategoriesManagerService {
  public categories: IFilterCategory[] = [];

  constructor(private _productApi: ProductsApiService,
              private _citiesApi: CitiesApiService) {
  }

  // Deprecated
  // this method should be renamed to getCategoriesForBakery
  public getCategories(bakeryId: number, locale?: string): Promise<IFilterCategory[]> {
    return this._productApi.getCategories(bakeryId, { locale })
      .then((categories: IFilterCategory[]) => {
        categories = this._transformCategories(categories);
        this.categories = categories;
        return categories;
      });
  }

  public getCategoriesByRefName(refName: string, params = {}): Promise<IFilterCategory[]> {
    return this._productApi.getCategoriesByRefName(refName, params)
      .then((response: IPaginatedResponse<IFilterCategory>) => {
        const categories = this._transformCategories(response.results);
        this.categories = categories;
        return categories;
      });
  }

  private _transformCategories(categories: IFilterCategory[]): IFilterCategory[] {
    return categories.map((c) => extend(c, {
      nameId: generateNameId(c.name, c.id)
    }));
  }
}
